export enum CalculatorTypes {
  AFFORDABILITY = "Affordability",
  REMORTGAGE = "Remortgage",
  STAMP_DUTY = "Stamp Duty",
  DEPOSIT = "Deposit",
  SMART_BUYER = "Smart Buyer",
  LTV = "LTV",
}

export const CalculatorTabNames = {
  Deposit: "How much can I borrow?",
  Affordability: "Mortgage repayments",
  Remortgage: "Remortgage",
  "Stamp Duty": "Stamp Duty",
  LTV: "Loan to Value",
};
